import createIcon from '../../createIcon';

/**
 * @component @name Dashboard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxM0gxMVYzSDNWMTNaTTMgMjFIMTFWMTVIM1YyMVpNMTMgMjFIMjFWMTFIMTNWMjFaTTEzIDNWOUgyMVYzSDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dashboard = createIcon('Dashboard', [
  [
    'path',
    { d: 'M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z', key: '18or4s' },
  ],
]);

export default Dashboard;
